import React, { Component } from 'react';
import Select from 'react-select';
import { dataUser, dataLocation } from '../Helpers/util';
import axiosInstance from '../../utils/axiosInstance';
import axios from 'axios';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwIconButton from '../Common/SwIconButton/SwIconButton';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';
const apiURL = require('./../../constant');
const URL_API = apiURL.PROD_URL;
const userDataLocal = dataUser();
const userDataLocal1 = dataLocation();
var UserObj = JSON.parse(userDataLocal);
var LocationObj = JSON.parse(userDataLocal1);
var vnArr = [];
var emailArr = [];
var phNoArr = [];
var nameArr = [];
var loadFilterData = true;

class ParkingReqFilterNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: [],
      company_id: UserObj.company_id,
      status: '',
      statusObj: null,
      vehicleType: '',
      vehicleTypeObj: null,
      vehicleNo: '',
      vehicleNoObj: null,
      email: '',
      emailObj: null,
      phone: '',
      phNoObj: null,
      name: '',
      nameObj: null,
      showFilter: false,
    };
  }

  componentDidMount() {
    if (loadFilterData) {
      nameArr = [];
      phNoArr = [];
      emailArr = [];
      vnArr = [];
      this.loadFilterData();
    }
  }

   loadFilterData = async () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));
  
    let article = {
      company_id: UserObj ? UserObj.company_id : null,
      location_id: LocationObj,
    };
  
    try {
      // Await the response from the axios request
      const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parking_filter`, article, {
        headers: {
          Authorization: authToken?.spintlyToken,
        },
      });
  
      // Extract data from the response
      let data = response.data.data;
  
      // Process the data and populate arrays
      data.forEach(element => {
        nameArr.push({
          value: element['user_name'],
          label: element['user_name'],
        });
        phNoArr.push({ value: element['phone'], label: element['phone'] });
        emailArr.push({ value: element['email'], label: element['email'] });
        vnArr.push({
          value: element['vehicle_number'],
          label: element['vehicle_number'],
        });
      });
  
      // Optionally, you can set the loadFilterData flag to false or use it as needed
      loadFilterData = false;
  
    } catch (error) {
      // Handle any error that might occur during the request
      console.error('Error loading filter data:', error);
    }
  };

  reload = e => {
    this.setState({
      status: '',
      statusObj: null,
      vehicleNo: '',
      vehicleNoObj: null,
      email: '',
      emailObj: null,
      phone: '',
      phNoObj: null,
      name: '',
      nameObj: null,
      vehicleType: '',
      vehicleTypeObj: null,
    });
    this.props.sendFilterToParent(null);
  };

  submitFilter = e => {
    e.preventDefault();
    const params = {};

    if (this.state.name) params.name = this.state.name;
    if (this.state.phone) params.phone = this.state.phone;
    if (this.state.email) params.email = this.state.email;
    if (this.state.vehicleNo) params.vehicle_number = this.state.vehicleNo;
    if (this.state.vehicleType) params.wheeler = this.state.vehicleType;
    if (this.state.status) params.status = this.state.status;

    this.props.sendFilterToParent(params);
  };

  setName = data => {
    this.setState({
      name: data.value,
      nameObj: data,
    });
  };

  setPhoneNo = data => {
    this.setState({
      phone: data.value,
      phNoObj: data,
    });
  };

  setEmail = data => {
    this.setState({
      email: data.value,
      emailObj: data,
    });
  };

  setVehicleNo = data => {
    this.setState({
      vehicleNo: data.value,
      vehicleNoObj: data,
    });
  };

  setVehicleType = data => {
    this.setState({
      vehicleType: data.value,
      vehicleTypeObj: data,
    });
  };

  setStatus = data => {
    this.setState({
      status: data.value,
      statusObj: data,
    });
  };

  render() {
    const vehicleType = [
      {
        value: 2,
        label: '2 Wheeler',
      },
      {
        value: 4,
        label: '4 Wheeler',
      },
    ];

    const status = [
      {
        value: '1',
        label: 'Pending',
      },
      {
        value: '2',
        label: 'Approved',
      },
      {
        value: '3',
        label: 'Assigned',
      },
      {
        value: '4',
        label: 'Deleted',
      },
      {
        value: '5',
        label: 'Delete Request',
      },
      {
        value: '6',
        label: 'Rejected',
      },
      {
        value: '7',
        label: 'Rejected by SW',
      },
    ];

    return (
      <>
  <SwOffCanvas
    show={this.state.showFilter}
    onClose={() => this.setState({ showFilter: false })}
    title="Parking Filters"
    placement="end"
    backdrop="static"
    keyboard={false}
    footer={
      <div className="d-flex justify-content-end gap-2">
        <SwButton
          variant='dark-outline'
          type="button"
          onClick={() => {
            this.reload();
            this.setState({ showFilter: false });
          }}
        >
          Reset
        </SwButton>

        <SwButton
          onClick={(e) => {
            this.submitFilter(e);
            this.setState({ showFilter: false });
          }}
        >
          Apply
        </SwButton>
      </div>
    }
  >
  <form>
    <div className="SwFormGroup">
      <label className="SwFormLabel">Name</label>
      <SwSelect
        value={this.state.nameObj}
        onChange={this.setName}
        options={nameArr}
        placeholder="Select Name"
      />
    </div>

    <div className="SwFormGroup">
      <label className="SwFormLabel">Phone No.</label>
      <SwSelect
        value={this.state.phNoObj}
        onChange={this.setPhoneNo}
        options={phNoArr}
        placeholder="Select Phone no."
      />
    </div>

    <div className="SwFormGroup">
      <label className="SwFormLabel">Email</label>
      <SwSelect
        value={this.state.emailObj}
        onChange={this.setEmail}
        options={emailArr}
        placeholder="Select Email"
      />
    </div>

    <div className="SwFormGroup">
      <label className="SwFormLabel">Vehicle Number</label>
      <SwSelect
        value={this.state.vehicleNoObj}
        onChange={this.setVehicleNo}
        options={vnArr}
        placeholder="Select Vehicle number"
      />
    </div>

    <div className="SwFormGroup">
      <label className="SwFormLabel">Vehicle Type</label>
      <SwSelect
        value={this.state.vehicleTypeObj}
        onChange={this.setVehicleType}
        options={[
          { value: 2, label: "2 Wheeler" },
          { value: 4, label: "4 Wheeler" },
        ]}
        placeholder="Select vehicle type"
      />
    </div>

    <div className="SwFormGroup">
      <label className="SwFormLabel">Status</label>
      <SwSelect
        value={this.state.statusObj}
        onChange={this.setStatus}
        options={[
          { value: "1", label: "Pending" },
          { value: "2", label: "Approved" },
          { value: "3", label: "Assigned" },
          { value: "4", label: "Deleted" },
          { value: "5", label: "Delete Request" },
          { value: "6", label: "Rejected" },
          { value: "7", label: "Rejected by SW" },
        ]}
        placeholder="Select Status"
      />
    </div>
  </form>
</SwOffCanvas>
        <SwIconButton size='sm' onClick={() => this.setState({ showFilter: true })}>
          <i className="bi bi-funnel" />
        </SwIconButton>
      </>
    );
  }
}

export default ParkingReqFilterNew;
